import { SpeakerSimpleHighIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Volume = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <SpeakerSimpleHighIcon {...rest} size={Sizes[size]} height={Sizes[size]} color={fill} />;
};

Volume.displayName = 'Volume';
